import React, { ReactElement } from 'react'
import { OrganizationDetailsPage } from 'src/ui/page/common/organization/details/OrganizationDetailsPage'

export const ServicePartnerDetailsPage = (): ReactElement => {
  return <OrganizationDetailsPage isServicePartner />
}
